export const ResourcesAnimation = {
  nm: "01",
  h: 281,
  w: 281,
  meta: { g: "LottieFiles Figma v91" },
  layers: [
    {
      ty: 4,
      nm: "Vector 5",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [24.75, 42.75] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [112.75, 135.75],
              t: 0,
            },
            { s: [112.75, 146.75], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              v: [
                [49.5, 28.5],
                [0, 0],
                [0, 56.5],
                [49.5, 85.5],
                [49.5, 28.5],
              ],
            },
          },
        },
        {
          ty: "st",
          nm: "",
          lc: 1,
          lj: 1,
          ml: 4,
          o: { a: 0, k: 100 },
          w: {
            a: 1,
            k: [
              { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [2], t: 0 },
              { s: [2], t: 75 },
            ],
          },
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [0.102, 0.102, 0.102],
                t: 0,
              },
              { s: [1, 1, 1], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 1,
    },
    {
      ty: 4,
      nm: "Vector 6",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [24.75, 42.75] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [130.75, 122.75] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              v: [
                [49.5, 28.5],
                [0, 0],
                [0, 56.5],
                [49.5, 85.5],
                [49.5, 28.5],
              ],
            },
          },
        },
        {
          ty: "st",
          nm: "",
          lc: 1,
          lj: 1,
          ml: 4,
          o: { a: 0, k: 100 },
          w: {
            a: 1,
            k: [
              { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [2], t: 0 },
              { s: [2], t: 75 },
            ],
          },
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [0.102, 0.102, 0.102],
                t: 0,
              },
              { s: [1, 1, 1], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 2,
    },
    {
      ty: 4,
      nm: "Vector 7",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [24.75, 42.75] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [148.75, 109.75],
              t: 0,
            },
            { s: [148.75, 84.75], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              v: [
                [49.5, 28.5],
                [0, 0],
                [0, 56.5],
                [49.5, 85.5],
                [49.5, 28.5],
              ],
            },
          },
        },
        {
          ty: "st",
          nm: "",
          lc: 1,
          lj: 1,
          ml: 4,
          o: { a: 0, k: 100 },
          w: {
            a: 1,
            k: [
              { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [2], t: 0 },
              { s: [2], t: 75 },
            ],
          },
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [0.102, 0.102, 0.102],
                t: 0,
              },
              { s: [1, 1, 1], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 3,
    },
    {
      ty: 4,
      nm: "Vector 8",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [24.75, 42.75] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [167.75, 97.75],
              t: 0,
            },
            { s: [167.75, 127.75], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              v: [
                [49.5, 28.5],
                [0, 0],
                [0, 56.5],
                [49.5, 85.5],
                [49.5, 28.5],
              ],
            },
          },
        },
        {
          ty: "st",
          nm: "",
          lc: 1,
          lj: 1,
          ml: 4,
          o: { a: 0, k: 100 },
          w: {
            a: 1,
            k: [
              { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [2], t: 0 },
              { s: [2], t: 75 },
            ],
          },
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [0.102, 0.102, 0.102],
                t: 0,
              },
              { s: [1, 1, 1], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 4,
    },
  ],
  v: "5.7.0",
  fr: 60,
  op: 75.01,
  ip: 0,
  assets: [],
};
